module.exports = __webpack_public_path__ + "static/feature-watchlist-2796b094a931c2b07c67fafdc9cc8ed9.png";